export default __webpack_public_path__ + "static/media/gambrel.17c0df6e.png";